var _defs, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    "data-name": "Camada 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 240 240",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#Gradiente_sem_nome_63);}.cls-2{fill:url(#Gradiente_sem_nome_65);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_63",
    x1: 8.08,
    y1: 158.13,
    x2: 139.7,
    y2: 26.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#141f34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#153150"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_65",
    x1: 92.96,
    y1: 211.96,
    x2: 225.36,
    y2: 79.56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#035552"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#20aea0"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M158.86,46.38H57.33A17.32,17.32,0,0,0,40,63.7V188.83a2.92,2.92,0,0,0,5,2.07h0l18.31-22.18a16.46,16.46,0,0,0,3.77-10.47V130.7a6.65,6.65,0,0,1,6.65-6.65H90.9a5.07,5.07,0,0,0,1.19-.16,6.22,6.22,0,0,0,3.19-2l14-16.3c3.13-3.14,2.17-7.53-2.26-7.53l-36.2.17a3.65,3.65,0,0,1-3.66-3.65l0-13.31a6.78,6.78,0,0,1,6.79-6.79l58.62-.34a14.31,14.31,0,0,0,10.22-4.36h0l17.55-20.51A1.8,1.8,0,0,0,158.86,46.38Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M79.61,193.9H184.53a15.2,15.2,0,0,0,15.2-15.19h0a12.52,12.52,0,0,0-12.52-12.52H118.52A2,2,0,0,1,117,163L197.26,66.9h0a12.13,12.13,0,0,0-.81-16.25h0a15.53,15.53,0,0,0-22.92,1L70.68,175.61h0a11.32,11.32,0,0,0,8.93,18.29Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.d29f73451d45cf5f79ef982ff9eb6202.svg";
export { ForwardRef as ReactComponent };